import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseReviewDetailFooter.module.scss'

import IconList from '@Ui/images/myhouse/IconList.svg'
import useMyhouse from '@Hooks/myhouse/useMyhouse'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import useReview from '@Hooks/myhouse/review/useReview'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

const MyhouseReviewDetailFooter: React.FC = () => {
  const { myhouse } = useMyhouse()
  const { complexNo } = myhouse
  const { review } = useReview()
  const detail = review?.detail
  const { prevSequence, nextSequence, prevContent, nextContent } = detail

  const history = useHistory()

  const articleClickHandler = (sequence: number) => (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    if (sequence) {
      history.push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews/${sequence}`)
    }
  }

  const listClickHandler = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    history.push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews`)
  }

  return (
    <div className={cx('myhouse_detail_footer')}>
      <a href="#" className={cx('myhouse_footer_link')} onClick={handleNclickMix(NCLICK.MY_HOUSE.REVIEW_DETAIL.PREVIOUS_POST, articleClickHandler(prevSequence))}>
        <span className={cx('myhouse_footer_label')}>이전글</span>
        <strong className={cx('myhouse_footer_title')}>{prevContent || '이전 리뷰가 없습니다'}</strong>
      </a>
      <a href="#" className={cx('myhouse_footer_link')} onClick={handleNclickMix(NCLICK.MY_HOUSE.REVIEW_DETAIL.NEXT_POST, articleClickHandler(nextSequence))}>
        <span className={cx('myhouse_footer_label')}>다음글</span>
        <strong className={cx('myhouse_footer_title')}>{nextContent || '다음 리뷰가 없습니다'}</strong>
      </a>
      <a href="#" className={cx('myhouse_link_list')} onClick={handleNclickMix(NCLICK.MY_HOUSE.REVIEW_DETAIL.LIST, listClickHandler)}>
        <IconList />
        목록보기
      </a>
    </div>
  )
}

export default MyhouseReviewDetailFooter
